import { render, staticRenderFns } from "./ExternalInformator.vue?vue&type=template&id=0818eac0&"
import script from "./ExternalInformator.vue?vue&type=script&lang=js&"
export * from "./ExternalInformator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports